module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search_panel":"Search Panel"},"si":{"search_panel":"සෙවුම් පැනලය"}}')
  delete Component.options._Ctor
}
